import React from "react";
interface InsightSVGProps {
  width?: string;
  height?: string;
  fill?: string;
}
export const InsightSVG: React.FC<InsightSVGProps> = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="30 0 500 500"
    >
      <text
        // eslint-disable-next-line react/no-unknown-property
        white-space="pre"
        fill={props.fill ?? "rgb(51, 51, 51)"}
        fontSize="30px"
        transform="matrix(6.975677, 0, 0, 7.393368, -517.475716, -398.341528)"
        y="92.78"
        x="76.83"
      >
        S+
      </text>
      <text
        // eslint-disable-next-line react/no-unknown-property
        white-space="pre"
        fill={props.fill ?? "rgb(51, 51, 51)"}
        fontSize="30px"
        x="140.581"
        y="287.987"
        transform="matrix(4.033137, 0, 0, 4.071396, -426.619574, -808.876782)"
      >
        Insight
      </text>
    </svg>
  );
};
